import { useCallback, useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ConversionDataContext, useInitConversionTagData } from '@bingads-webui-campaign-react/conversion-data';

import { generateEventTag } from './generate-event-tag';

export function useEventTag({
  action,
  currencyCode,
  goalValue,
  goalValueType,
}) {
  const i18n = useContext(I18nContext);
  const { tagContext } = useContext(ConversionDataContext);
  useInitConversionTagData(tagContext);

  const { data: tag } = tagContext;
  const tagId = useMemo(() => tag && tag.id, [tag]);
  const tagType = useMemo(() => tag && tag.type, [tag]);
  const functionName = useMemo(() => (tagType === 'UET' ? 'uet_report_conversion' : 'report_conversion'), [tagType]);

  const generateEventTagParams = useMemo(() => ({
    action,
    currencyCode,
    goalValue,
    goalValueType,
    i18n,
  }), [action, currencyCode, goalValue, goalValueType, i18n]);

  const getEventTag = useCallback((isPageLoad = false) => {
    const newTagType = isPageLoad ? `${tagType}PageLoad` : tagType;
    return generateEventTag({ ...generateEventTagParams, tagType: newTagType });
  }, [generateEventTagParams, tagType]);

  const getExampleCodeSnippet = useCallback((isPageLoad = false) => {
    const exampleTagType = isPageLoad ? `${tagType}PageLoadExample` : `${tagType}Example`;
    return generateEventTag({ ...generateEventTagParams, tagType: exampleTagType });
  }, [generateEventTagParams, tagType]);

  return {
    functionName,
    getEventTag,
    getExampleCodeSnippet,
    tagId,
    tagType,
  };
}
